export const usersStatisticsPath = () => {
  return '/statistics/users';
};
